import { useListRegisterBillService } from "./hooks"
import { Card, Loading } from "components"
import { TabBillStatusParams } from "./types"
import { Fragment, useEffect, useState } from "react"
import { FilterRegisterBillService, FotherSection, TableRegisterBillService } from "./components"

export const RegisterBillServiceList = () => {
  const listRegisterBillService = useListRegisterBillService()
  const [selected, setSelected] = useState<TabBillStatusParams>({ 
    search: "", 
    start_date: "", 
    end_date: "", 
    approve_status: "", 
    bill_status: "" 
  })
  
  useEffect(() => {
    if (!selected.start_date || !selected.end_date) return;

    const filteredSelected: Partial<TabBillStatusParams> = {};

    (Object.keys(selected) as Array<keyof TabBillStatusParams>).forEach(key => {
      if (selected[key]) {
        filteredSelected[key] = selected[key];
      }
    });

    listRegisterBillService.refetch(filteredSelected);

    // eslint-disable-next-line
  }, [selected]);


  return (
    <Fragment>
      <section className="mt-2">
        <Card>
          <Card.Body>
            <FilterRegisterBillService
              selected={selected}
              setSelected={setSelected}
            />
          </Card.Body>
        </Card>
      </section>

      {listRegisterBillService.isLoading
        ? <Card className="mt-2"><Card.Body><div className="flex justify-center py-12"><Loading loading /></div></Card.Body></Card>
        : <>
          <section className="mt-2">
            <Card>
              <Card.Body>
                <TableRegisterBillService
                  data={listRegisterBillService?.data}
                  isLoading={listRegisterBillService.isLoading}
                  refetch={() => {
                    const filteredSelected: Partial<TabBillStatusParams> = {};

                    (Object.keys(selected) as Array<keyof TabBillStatusParams>).forEach(key => {
                      if (selected[key]) { filteredSelected[key] = selected[key] }
                    });

                    listRegisterBillService.refetch(filteredSelected);
                  }}
                />
              </Card.Body>
            </Card>
          </section>

          <section className="mt-2">
            <Card>
              <Card.Body>
                <FotherSection data={listRegisterBillService?.data} />
              </Card.Body>
            </Card>
          </section>
        </>
      }
    </Fragment>
  )
}
